import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseSelectComponent } from "../base/base-select";

@Component({
	selector: "app-select",
	templateUrl: "select.component.html",
	styleUrl: "select.component.scss",
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SelectComponent),
			multi: true,
		},
	],
})
export class SelectComponent extends BaseSelectComponent implements ControlValueAccessor {
	@Input() public items: any[];
	@Input() public invalid: boolean = false;
	@Input() public appendTo: string | null = null;

	value: any;
	onChange = (value: any) => {};
	onTouched = () => {};

	writeValue(value: any): void {
		this.value = value;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	isDarkMode(): boolean {
		return document.documentElement.getAttribute("data-bs-theme") === "dark";
	}
	onClear(event) {
		this.clear.emit(event);
	}
}
